import { useState } from 'react';
import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import { InfoBanner, useCookieContext } from '@spotahome/ui-library';
import { DSIcon } from '@spotahome/ui-library/base';

import './ValueProposition.scss';

export const COOKIE_NAME = 'sah-search-value-proposition';
export const COOKIE_VALUE = 1;
const COOKIE_15_DAYS = 60 * 60 * 24 * 15;

const BULLET_POINTS = [
  {
    renderIcon: () => (
      <DSIcon name="device_portrait" className="value-proposition__icon" />
    ),
    key: 'search.value_proposition.rentals'
  },
  {
    renderIcon: () => (
      <DSIcon name="check_circle" className="value-proposition__icon" />
    ),
    key: 'search.value_proposition.fraud-protection'
  },
  {
    renderIcon: () => (
      <DSIcon name="diamond" className="value-proposition__icon" />
    ),
    key: 'search.value_proposition.cancellation'
  }
];

const ValueProposition = ({ className = '' }) => {
  const { getCookie, setCookie } = useCookieContext();
  const [isClosed, setIsClosed] = useState(!!getCookie(COOKIE_NAME));
  const handleClose = () => {
    setCookie(COOKIE_NAME, COOKIE_VALUE, { maxAge: COOKIE_15_DAYS });
    setIsClosed(true);
  };

  if (isClosed || getCookie(COOKIE_NAME)) {
    return null;
  }

  const bullets = BULLET_POINTS;

  return (
    <InfoBanner
      className={className}
      closePosition="center"
      onCloseBanner={handleClose}
      content={bullets.map(bulletPoint => (
        <div className="value-proposition__bullet-point" key={bulletPoint.key}>
          {bulletPoint.renderIcon()}
          <p className="value-proposition__bullet-point__text">
            {trans(bulletPoint.key)}
          </p>
        </div>
      ))}
    />
  );
};

ValueProposition.propTypes = {
  className: PropTypes.string
};

export default ValueProposition;
